import { ConsoleLogger, LogLevels, } from "@plansoft-configuration-renderer/utils";
const logger = new ConsoleLogger("layout", LogLevels.warn);
export const logIssue = (msg, ...data) => {
    logger.log(`%c${msg}`, "background-color:yellow", ...data);
};
export const logInfo = (msg, ...data) => {
    logger.info(`%c${msg}`, "background-color:lightgreen", ...data);
};
//# sourceMappingURL=layoutLogger.js.map